/** Form helpers for the two partner-raised document flows: upload yourself, or ask the client. */

let rowCounter = 0;

export const emptyRequestItem = () => ({
  key: `item-${rowCounter++}`,
  label: "",
  instructions: "",
  required: true,
});

export const emptyUploadRow = () => ({ key: `upload-${rowCounter++}`, label: "", files: [] });

const named = (rows) => rows.filter((row) => String(row.label || "").trim());

export const validateRequestForm = ({ title, items }) => {
  if (!String(title || "").trim()) return "Give the request a title.";
  if (!items?.length) return "Add at least one document.";
  if (items.some((item) => !String(item.label || "").trim())) return "Every document needs a name.";
  return null;
};

export const validateUploadRows = (rows) => {
  if (!rows?.length) return "Add at least one document.";
  if (rows.some((row) => !String(row.label || "").trim())) return "Every document needs a name.";
  if (rows.some((row) => !row.files?.length)) return "Every document needs at least one file.";
  return null;
};

export const buildRequestPayload = ({ title, items }) => ({
  title: String(title || "").trim(),
  items: named(items).map((item) => ({
    label: item.label.trim(),
    instructions: String(item.instructions || "").trim(),
    required: Boolean(item.required),
    maxFiles: null,
  })),
});

/** Every uploaded document is required, so the request is complete as soon as the files land. */
export const buildUploadPayload = ({ title, rows }) => ({
  title: String(title || "").trim() || "Documents from the referral partner",
  items: named(rows).map((row) => ({
    label: row.label.trim(),
    instructions: "",
    required: true,
    maxFiles: null,
  })),
});

/**
 * Pairs each form row with the item the server created for it: by position, falling back to the
 * label, so the files go onto the document the partner named.
 */
export const pairRowsWithItems = (rows, createdItems = []) =>
  named(rows).map((row, index) => {
    const byIndex = createdItems[index];
    const item =
      byIndex && byIndex.label === row.label.trim()
        ? byIndex
        : createdItems.find((candidate) => candidate.label === row.label.trim()) || byIndex;
    return { row, itemId: item?.id };
  });
